var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading,"height":"420","id":"container","flat":""}},[_c('v-card-title',{staticClass:"d-flex align-center py-1"},[_c('h5',{staticClass:"mr-auto"},[_vm._v("Active Campaigns")])]),_c('v-divider'),_c('apexchart',{attrs:{"type":"pie","height":"370","options":_vm.donutOptions,"series":_vm.donutData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }